import React from "react"

interface Props {
   children: JSX.Element | JSX.Element[]
}

export default function DataRow({children}: Props) {
   return <div className="w-full flex flex-col gap-5 md:flex-row md:gap-6 md:justify-between">{children}</div>
}


